import React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import { Chevron } from 'components/Icons/Icons';
import prefixUtil from 'utils/PrefixUtil';
import styles from './FluidCarousel.css';
const BUFFER = 25;
export default class FluidCarouselVariableWidth extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            scrollLength: 0,
            itemsInView: 0,
            itemsOnLeft: 0
        };
        this.getContainerWidth = ({ purgeCache = false } = {}) => {
            if (this.containerWidth && !purgeCache)
                return this.containerWidth;
            if (this.carousel) {
                const gbrc = this.carousel.getBoundingClientRect();
                if (gbrc && gbrc.width)
                    return gbrc.width;
            }
            return 0;
        };
        this.handleBack = () => {
            this.containerWidth = this.getContainerWidth();
            let itemsToBeScrolledToRight = 0;
            let widthOfItemsToBeScrolledToRight = 0;
            let itemsInFullView = 0;
            let widthOfItemsInFullView = 0;
            if (this.items) {
                for (let index = this.state.itemsOnLeft; index < this.items.childNodes.length; index++) {
                    const element = this.items.childNodes[index];
                    if (element.offsetWidth + widthOfItemsToBeScrolledToRight < this.containerWidth) {
                        itemsToBeScrolledToRight += 1;
                        widthOfItemsToBeScrolledToRight += element.offsetWidth;
                    }
                    else {
                        break;
                    }
                }
                for (let index = this.state.itemsOnLeft + itemsToBeScrolledToRight - 1; index < this.items.childNodes.length; index++) {
                    const element = this.items.childNodes[index];
                    if (element.offsetWidth + widthOfItemsInFullView < this.containerWidth) {
                        itemsInFullView += 1;
                        widthOfItemsInFullView += element.offsetWidth;
                    }
                    else {
                        break;
                    }
                }
            }
            // Pro-rated scroll length will be already scrolled - width of fully visible items
            let scrollLength = this.state.scrollLength - widthOfItemsToBeScrolledToRight;
            // If previously scroll length is less then the length of items in view
            // that means there are lesser items left and hence scroll to 0
            if (this.state.scrollLength < widthOfItemsToBeScrolledToRight) {
                scrollLength = 0;
            }
            const itemsLeft = this.itemsOnLeft || this.state.itemsOnLeft;
            if (itemsLeft === 0) {
                scrollLength = scrollLength - BUFFER;
                this.handleShake(-BUFFER);
            }
            const itemsOnLeft = Math.max(this.state.itemsOnLeft - itemsToBeScrolledToRight, 0);
            if (this.props.onScroll) {
                this.props.onScroll(itemsOnLeft, itemsInFullView);
            }
            this.items && this.items.addEventListener('transitionend', this.handleTransitionEnd);
            this.addWillChangeDuringTransition(scrollLength);
            this.setState({
                scrollLength,
                itemsOnLeft
            });
        };
        this.handleForward = (event, itemsOnLeft) => {
            this.containerWidth = this.getContainerWidth();
            let itemsToBeScrolledToLeft = 0;
            let widthOfItemsToBeScrolledToLeft = 0;
            let itemsInFullView = 0;
            let widthOfItemsInFullView = 0;
            const allItemsWidth = this.getWidthOfAllItems();
            const childrenLength = get(this.props.children, 'length', 0);
            if (this.items) {
                for (let index = this.state.itemsOnLeft; index < this.items.childNodes.length; index++) {
                    const element = this.items.childNodes[index];
                    if (element.offsetWidth + widthOfItemsToBeScrolledToLeft < this.containerWidth) {
                        itemsToBeScrolledToLeft += 1;
                        widthOfItemsToBeScrolledToLeft += element.offsetWidth;
                    }
                    else {
                        break;
                    }
                }
                if (this.items.childNodes.length - (this.state.itemsOnLeft + itemsToBeScrolledToLeft) > 0) {
                    for (let index = this.state.itemsOnLeft + itemsToBeScrolledToLeft; index < this.items.childNodes.length; index++) {
                        const element = this.items.childNodes[index];
                        if (element.offsetWidth + widthOfItemsInFullView < this.containerWidth) {
                            itemsInFullView += 1;
                            widthOfItemsInFullView += element.offsetWidth;
                        }
                        else {
                            break;
                        }
                    }
                }
            }
            let items = this.state.itemsOnLeft;
            if (!isNaN(itemsOnLeft)) {
                items = itemsOnLeft;
            }
            items += itemsToBeScrolledToLeft;
            // Prorated scroll length based on the previous items fully visible and current items that are fully visible
            let scrollLength = this.state.scrollLength + widthOfItemsToBeScrolledToLeft;
            // If width of all items - pro-rated scroll length is less than scroll length
            // it means, there are less No. of items left than what we are proposing,
            // hence find the diff and add to the previous scrolled length
            if (allItemsWidth - scrollLength <= this.containerWidth) {
                scrollLength = allItemsWidth - this.containerWidth;
                widthOfItemsInFullView = 0;
                itemsInFullView = 0;
                items = this.items.childNodes.length;
                for (let index = this.items.childNodes.length - 1; index > -1; index--) {
                    const element = this.items.childNodes[index];
                    if (element.offsetWidth + widthOfItemsInFullView < this.containerWidth) {
                        itemsInFullView += 1;
                        items -= 1;
                        widthOfItemsInFullView += element.offsetWidth;
                    }
                    else {
                        break;
                    }
                }
            }
            const itemsInView = this.itemsInView || this.state.itemsInView;
            const itemsLeft = this.itemsOnLeft || this.state.itemsOnLeft;
            if (itemsLeft + itemsInView >= childrenLength) {
                if (itemsLeft === 0)
                    scrollLength = 0;
                scrollLength = scrollLength + BUFFER;
                this.handleShake(BUFFER);
            }
            // If this is a genuine click event and not a windows resize.
            if (event) {
                if (this.props.onScroll) {
                    this.props.onScroll(items, itemsInFullView);
                }
                this.items && this.items.addEventListener('transitionend', this.handleTransitionEnd);
            }
            else {
                // If this is a resize event.
                // FIXME: fix if block @ankeetmaini/@mathan
                if (this.props.onResize) {
                    this.props.onResize(items, itemsInFullView);
                }
            }
            this.itemsInView = itemsInFullView;
            items = items <= 0 ? 0 : items;
            this.addWillChangeDuringTransition(scrollLength);
            this.setState({
                scrollLength,
                itemsOnLeft: items,
                // Set because, when resized, this should be updated.
                itemsInView: itemsInFullView
            });
        };
        this.handleShake = buffer => {
            this.timeout && clearTimeout(this.timeout);
            this.items && this.items.addEventListener('transitionend', this.removeWillChange);
            this.addWillChangeDuringTransition();
            this.timeout = window.setTimeout(() => {
                const len = this.state.scrollLength - buffer;
                this.setState({
                    scrollLength: len
                });
            }, 300);
        };
        this.addWillChangeDuringTransition = (scrollLength) => {
            const style = get(this, ['carousel', 'style']);
            if (scrollLength !== 0 && style) {
                style.willChange = 'transform';
            }
        };
        this.removeWillChange = () => {
            const style = get(this, ['carousel', 'style']);
            if (style)
                style.willChange = null;
        };
        this.handleTransitionEnd = () => {
            this.items && this.items.removeEventListener('transitionend', this.handleTransitionEnd);
            this.removeWillChange();
            if (this.props.onTransitionEnd) {
                this.props.onTransitionEnd(this.state.itemsOnLeft, this.state.itemsInView);
            }
        };
        this.resetCarousel = () => this.setState({ scrollLength: 0, itemsOnLeft: 0 });
        this.carouselRef = item => (this.carousel = item);
        this.itemsRef = item => (this.items = item);
    }
    componentDidMount() {
        this.containerWidth = this.getContainerWidth();
        const itemsInView = this.getNumberOfItemsInFullView();
        if (this.props.onTransitionEnd) {
            this.props.onTransitionEnd(0, itemsInView);
        }
        this.itemsInView = itemsInView;
        this.itemsOnLeft = 0;
        this.forceUpdate();
    }
    getNumberOfItemsInFullView() {
        let itemsInFullView = 0;
        let widthOfItemsInFullView = 0;
        if (this.items && this.items.childNodes.length - this.state.itemsOnLeft > 0) {
            for (let index = this.state.itemsOnLeft; index < this.items.childNodes.length; index++) {
                const element = this.items.childNodes[index];
                if (element.offsetWidth + widthOfItemsInFullView < this.containerWidth) {
                    itemsInFullView += 1;
                    widthOfItemsInFullView += element.offsetWidth;
                }
                else {
                    break;
                }
            }
        }
        return itemsInFullView;
    }
    getWidthOfAllItems() {
        let allItemsWidth = 0;
        if (this.items) {
            for (let index = 0; index < this.items.childNodes.length; index++) {
                const element = this.items.childNodes[index];
                allItemsWidth += element.offsetWidth;
            }
        }
        return allItemsWidth;
    }
    componentWillUnmount() {
        this.timeout && clearTimeout(this.timeout);
    }
    render() {
        const itemsInView = this.itemsInView || this.state.itemsInView;
        const itemsOnLeft = this.itemsOnLeft || this.state.itemsOnLeft;
        const childrenLength = get(this.props.children, 'length', 0);
        const { scrollLength } = this.state;
        const { smallButtons, smallerButtons, rightBtnClass, leftBtnClass, firstItemClass = '', lastItemClass = '', overflowHidden = true, fadeEdge = false } = this.props;
        const disableRightBtn = itemsOnLeft + itemsInView >= childrenLength;
        const disableLeftBtn = itemsOnLeft === 0;
        const hideBtns = this.getWidthOfAllItems() < this.containerWidth;
        return (<div className={cx(styles['fluid-carousel'], this.props.containerWrapperClassName, {
            [styles['overflow-hidden']]: overflowHidden
        })} ref={this.carouselRef}>
				<div className={styles['fluid-carousel-container-inner-wrapper']}>
					<div className={cx(styles['container'], this.props.containerClassName, {
            [styles['overflow-hidden']]: overflowHidden
        })}>
						<div ref={this.itemsRef} className={cx(styles['items'], this.props.itemsClass)} style={prefixUtil({ transform: `translateX(${-scrollLength}px)` })}>
							{(this.props.children || []).map((child, i) => {
            return (<div className={cx(styles['item'], this.props.itemClass, {
                [firstItemClass]: i === 0,
                [lastItemClass]: i === childrenLength - 1
            })} key={i}>
										{child}
									</div>);
        })}
						</div>
					</div>

					<div className={cx(styles['btn-fluid-carousel-container'], styles['left'], {
            [styles['hidden']]: hideBtns,
            [styles['disabled']]: disableLeftBtn,
            [styles['fade-edge']]: fadeEdge
        })}>
						<div onClick={this.handleBack} className={cx(styles['btn-fluid-carousel'], leftBtnClass, styles['btn-left'], {
            [styles['small']]: smallButtons,
            [styles['smaller']]: smallerButtons
        })} data-aid="left-btn-fluid-carousel">
							<Chevron pathClassName={styles['chevron-icon']} width={14.6} height={smallButtons || smallerButtons ? 15 : 24}/>
						</div>
					</div>

					<div className={cx(styles['btn-fluid-carousel-container'], styles['right'], {
            [styles['hidden']]: hideBtns,
            [styles['disabled']]: disableRightBtn,
            [styles['fade-edge']]: fadeEdge
        })}>
						<div onClick={this.handleForward} className={cx(styles['btn-fluid-carousel'], rightBtnClass, styles['btn-right'], {
            [styles['small']]: smallButtons,
            [styles['smaller']]: smallerButtons
        })} data-aid="right-btn-fluid-carousel">
							<Chevron className={styles['chevron-icon-right']} pathClassName={styles['chevron-icon']} width={14.6} height={smallButtons || smallerButtons ? 15 : 24}/>
						</div>
					</div>
				</div>
			</div>);
    }
}
